import { render, staticRenderFns } from "./AddSuperUser.vue?vue&type=template&id=06f2ebcd&scoped=true&"
import script from "./AddSuperUser.vue?vue&type=script&lang=js&"
export * from "./AddSuperUser.vue?vue&type=script&lang=js&"
import style0 from "./AddSuperUser.vue?vue&type=style&index=0&id=06f2ebcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f2ebcd",
  null
  
)

export default component.exports